export default __webpack_public_path__ + "static/media/bell.ac5fe8f3.svg";